export enum Icons {
  FLAG_GOALS = "ic ic-flag-goal"
}
